var _path, _circle, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAvailableBlack = function SvgIconAvailableBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 83,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FB",
    d: "M28.402 2.036C-10.692 6.626.374 45.439 10.351 65.857c9.782 17.851 22.71 19.018 49.263 12.018 24.807-6.54 38.666-17.735 27.719-48.537C77.008.288 73.124-3.214 28.403 2.036"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.644,
    cy: 40.516,
    r: 24.662,
    fill: "#F5F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M58.146 33.857a2.95 2.95 0 0 1-.654.963L44.797 47.306a2.23 2.23 0 0 1-3.111 0l-6.364-6.26a2.94 2.94 0 0 1 0-4.213 3.057 3.057 0 0 1 4.278 0l3.644 3.58 9.967-9.8a3.06 3.06 0 0 1 4.28 0 2.95 2.95 0 0 1 .655 3.244"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    d: "M56.534 33.383a2.95 2.95 0 0 0 .885-2.103 2.94 2.94 0 0 0-.885-2.104 3.063 3.063 0 0 0-4.28 0l-9.968 9.8-1.149-1.149m-2.495-2.43a3.057 3.057 0 0 0-4.278 0 2.94 2.94 0 0 0 0 4.212l6.364 6.26a2.23 2.23 0 0 0 3.11 0L54.14 35.728"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeOpacity: 0.8,
    strokeWidth: 2,
    d: "M45.447 12.981c13.488 0 24.422 10.934 24.422 24.422A24.3 24.3 0 0 1 67.6 47.7m-7.068 8.913a25 25 0 0 0 2.395-2.152m-6.944 4.983a24.3 24.3 0 0 1-10.535 2.383c-13.488 0-24.422-10.935-24.422-24.423 0-10.272 6.342-19.063 15.323-22.67"
  })));
};
export default SvgIconAvailableBlack;